import empty from './ant_empty'

export default {
  install (Vue) {
    Vue.directive('empty', empty)
  }
}